<template>
  <div class="page">
    <Share :data="shareData"></Share>
    <common-image :data="CommonImage0"></common-image>
    <common-image :data="CommonImage1"></common-image>
    <common-image :data="CommonImage2"></common-image>
    <common-image :data="CommonImage3"></common-image>
    <common-image :data="CommonImage4"></common-image>
  </div>
</template>

<script>
import Share from '../../components/share.vue'
/* eslint-disable */
export default {
  data() {
    return {
      CommonImage0: {"src":"https://luban-1254024480.cos.ap-beijing.myqcloud.com/project/imgs/1566444133302.gif","style":{"width":"100%"},"href":""},
      CommonImage1: {"src":"https://luban-1254024480.cos.ap-beijing.myqcloud.com/project/imgs/1619417013568.jpg","style":{"width":"100%"},"href":"https://www.shuidigongyi.com/gongyi/case/PF565141798226233124"},
      CommonImage2: {"src":"https://luban-1254024480.cos.ap-beijing.myqcloud.com/project/imgs/1619417071016.jpg","style":{"width":"100%"},"href":"https://www.shuidigongyi.com/gongyi/case/PF498096144857971883"},
      CommonImage3: {"src":"https://luban-1254024480.cos.ap-beijing.myqcloud.com/project/imgs/1619417108589.jpg","style":{"width":"100%"},"href":"https://www.shuidigongyi.com/gongyi/case/PF592043713169992702"},
      CommonImage4: {"src":"https://luban-1254024480.cos.ap-beijing.myqcloud.com/project/imgs/1566444249104.gif","style":{"width":"100%"},"href":"https://www.shuidichou.com/gongyi/?channel=pf_wx_90_gongmushouye_menu0724&wxMpType=90&_menu_id_=q0bXjonI&_button_id_=hVDWQCZ67&from_wx_mp_type=90&version=1554803916Cxm"},
      shareData: {"title":"水滴公益紧急救助，为生命接力！","bgColor":"#fff","bgImage":"","shareTitle":"水滴紧急救助：一起为生命接力","shareDesc":"益起公益，益起爱","shareImg":"https://luban-1254024480.cos.ap-beijing.myqcloud.com/project/imgs/1566790270860.png","shareLink":"","sdDataBiz":"cf","bi_custom_params":{"project_id_luban":"xtkithd2m7ji"},"userThirdScope":"base","thirdType":17}
    }
  },
  components: {
    Share
  }
}
</script>

<style scoped>
.page {
  background-color: #fff;
  background-image: url();
  background-repeat: no-repeat;
  background-size: ;
  padding: ;
}
</style>
